<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.tips{
  padding-top: 15px;
  color: red;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div" style="width: 102px">评分内容：</div>
          <el-input v-model="page.paramName" class="ipt-sty" placeholder="请输入评分内容"></el-input
        ></el-col>
        <div style="text-align:right;padding-right:15px;">
          <el-button size="medium" type="info" @click="search">搜索</el-button>
          <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
        </div>
      </el-row>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addVersion">新增评分内容</el-button>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="campaignsState"
          label="评分内容"
          show-overflow-tooltip
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.paramName }}</template>
        </el-table-column>
        <el-table-column label="展示顺序" width="100" header-align="center" align="right">
          <template slot-scope="scope">
            {{ scope.row.paramValue1 }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" width="100" label="创建人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="createTime" width="100" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="240px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="setCheck(scope.row)">设置评分机制 ｜</a>
            <a class="txt-color" @click="editVersion(scope.row)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle"  :visible.sync="dialogVisible" width="40%">
      <el-form label-width="100px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">评分内容</span>
          <el-input type="input" placeholder="请输入" v-model="paramName">
          </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">展示顺序</span>
          <el-input type="number"  placeholder="请填写排序" v-model="paramValue1"> </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label">评分说明</span>
          <el-input type="textarea" placeholder="请输入" v-model="paramValue2">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增评分内容'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>

    <el-dialog :title="dialogTxt" :visible.sync="dialogCheckVisible" width="600px">
      <div style="float: right; margin-bottom: 20px">
        <el-button icon="el-icon-plus" size="medium" type="info" @click="addRow">新增</el-button>
      </div>
      <el-table :data="evaluationTable" border style="width: 100%">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <el-table-column label="区间最小值" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input
              class="check-table-input"
              type="input"
              style="width: 100%; float: left"
              :maxlength="30"
              placeholder="请输入"
              v-model="scope.row.min"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
            />
          </template>
        </el-table-column>
        
        <el-table-column label="区间最大值" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input
              type="input"
              class="check-table-input"
              style="width: 100%; float: left"
              :maxlength="30"
              placeholder="请输入"
               v-model="scope.row.max"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
            />
          </template>
        </el-table-column>
         <el-table-column label="分值" header-align="center" align="center">
          <template slot-scope="scope">
            <el-input
              class="check-table-input"
              type="input"
              style="width: 100%; float: left"
              :maxlength="30"
              placeholder="请输入"
               v-model="scope.row.score"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
            />
          </template>
        </el-table-column>

        <el-table-column prop="bank" min-width="60px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="delRow(scope.$index)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="tips">备注：包含区间最小值，不包含区间最大值，比如区间最小值为20，区间最大值为30，表示[20,30)则为≥20，＜30</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogCheckVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          @click="saveEvaluationContent"
          v-loading.fullscreen.lock="fullscreenLoading"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增评分内容',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        bizType: '评分管理',
        paramName: '', //评分内容
        tenantGuid:localStorage.guid,
        orderByName:'param_value1',
        orderByType:'asc'
      },
      detail:'',
      paramName: '',//评分内容
      paramValue1: '',//排序
      paramValue2:'',//说明
      guid:'',
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,

      dialogTxt: '设置评分机制',
      dialogCheckVisible: false,
      evaluationTable: [],
      taskEvaluationGuid: '',
      evaluationTypeList: [
        { label: '数量要求', value: '1' },
        { label: '质量要求', value: '2' },
      ],
      isPassList:[
        { label: '合格', value: 'Y' },
        { label: '不合格', value: 'N' },
      ]
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        bizType: '评分管理',
        paramName: '', //评分内容
        tenantGuid:localStorage.guid,
        orderByName:'param_value1',
        orderByType:'asc'
      };
      this.getList();
    },
    addVersion() {
      this.textTitle = '新增评分内容';
      this.paramName = '';
      this.paramValue1 = '';
      this.paramValue2 = '';
      this.dialogVisible = true;
    },
    editVersion(detail) {
      this.textTitle = '编辑评分内容';
      this.dialogVisible = true;
      this.guid = detail.guid;
      this.paramName =detail.paramName;
      this.paramValue =detail.paramValue;
      this.paramValue1 = detail.paramValue1;
      this.paramValue2 = detail.paramValue2;
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
            self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/delete?guid=${guid}`).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
                } else {
                self.$message.error(res.data.msg);
                }
            });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.paramName) {
        self.$message.error('请输入评分内容');
        return;
      }
      if (!this.paramValue1) {
        self.$message.error('请输入排序');
        return;
      }
      var req = {
        paramName: this.paramName,
        bizType: '评分管理',
        tenantGuid:localStorage.guid,
        paramName:this.paramName,
        paramValue1:this.paramValue1,
        paramValue2:this.paramValue2
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.paramName) {
        self.$message.error('请输入评分内容');
        return;
      }
      if (!this.paramValue1) {
        self.$message.error('请输入排序');
        return;
      }
      var req = {
        paramName: this.paramName,
        bizType: '评分管理',
        tenantGuid:localStorage.guid,
        paramName:this.paramName,
        paramValue:this.paramValue,
        paramValue1:this.paramValue1,
        paramValue2:this.paramValue2,
        guid:this.guid
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    setCheck(detail) {
      this.dialogCheckVisible = true;
      this.detail = detail;
      if(this.detail.paramValue){
        this.evaluationTable = JSON.parse(this.detail.paramValue)
      }else{
        this.evaluationTable = [];
      }
    },
    saveEvaluationContent() {
     let self = this;
      if(!this.evaluationTable||this.evaluationTable.length==0){
        this.$message.error('请新增评分机制！');
        return
      }
      try {
        this.evaluationTable.forEach((item) => {
          item.score = +item.score 
          if (!item.score) {
            throw new Error('请填写分值！');
          }
         item.score = +item.score;
         item.min = +item.min;
         item.max = +item.max;
        });
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      console.log(this.evaluationTable)
      let req = {
        guid:this.detail.guid,
        paramName:this.detail.paramName,
        paramValue1:this.detail.paramValue1,
        paramValue2:this.detail.paramValue2,
        paramValue:JSON.stringify(this.evaluationTable),
        bizType: '评分管理',
        guid:this.detail.guid
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('设置成功');
          self.page.pageIndex = 1;
          self.dialogCheckVisible = false;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });


    },
    addRow(index) {
      this.evaluationTable.push({
        min:'',
        max:'',
        score:''
      });
    },
    delRow(index) {
      this.evaluationTable.splice(index, 1);
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>
<style >
.check-table-input .el-input__inner{
  text-align: right !important;;
}
</style>